import React, { createContext, useContext, useEffect, useState } from 'react';
import { collection, onSnapshot, orderBy, query, limit } from 'firebase/firestore';
import { db } from '../firebase';
import { useCompany } from './CompanyContext';

/**
 * CampaignsContext
 *
 * Provides real-time read of companies/{cId}/campaigns.
 * Campaign writes go through the backend API (/api/campaigns).
 */

const CampaignsContext = createContext(null);

export const useCampaigns = () => {
  const ctx = useContext(CampaignsContext);
  if (!ctx) throw new Error('useCampaigns must be used within CampaignsProvider');
  return ctx;
};

export const CampaignsProvider = ({ children }) => {
  const { companyId } = useCompany();
  const [campaigns, setCampaigns] = useState([]);
  const [loading, setLoading]     = useState(true);

  useEffect(() => {
    if (!db || !companyId) { setLoading(false); return; }

    const q = query(
      collection(db, 'companies', companyId, 'campaigns'),
      orderBy('createdAt', 'desc'),
      limit(100),
    );

    const unsub = onSnapshot(
      q,
      (snap) => {
        setCampaigns(snap.docs.map((d) => ({ id: d.id, ...d.data() })));
        setLoading(false);
      },
      (err) => {
        console.error('[CampaignsContext] snapshot error:', err);
        setLoading(false);
      },
    );
    return unsub;
  }, [companyId]);

  return (
    <CampaignsContext.Provider value={{ campaigns, loading }}>
      {children}
    </CampaignsContext.Provider>
  );
};

export default CampaignsContext;
